// Official Robinhood logo (path from simple-icons), used as the Robinhood Chain network mark.
const ROBINHOOD_PATH =
  "M2.84 24h.53c.096 0 .192-.048.224-.128C7.591 13.696 11.94 8.656 14.67 5.638c.112-.128.064-.225-.096-.225h-4.88a.55.55 0 0 0-.45.225L5.746 9.972c-.514.642-.642 1.236-.642 2.086v4.43c-1.14 3.194-1.862 5.361-2.392 7.32-.032.125.016.192.129.192M20.447.646c-.754-.802-4.157-.834-5.73-.224a3 3 0 0 0-.786.465 41 41 0 0 0-3.323 3.178c-.112.113-.064.225.097.225h5.409c.497 0 .786.289.786.786v6.1c0 .16.128.208.225.064l3.258-4.254c.53-.69.69-.898.835-1.861.192-1.413.08-3.58-.77-4.479m-6.982 16.18 2.231-3.676a.7.7 0 0 0 .064-.29V6.73c0-.16-.112-.225-.224-.097-3.355 3.74-5.971 7.672-8.395 12.407-.06.12.016.225.16.177l5.009-1.54c.565-.174.882-.402 1.155-.852";

export function RobinhoodGlyph({ size = 16, color = "#00DC82", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={ROBINHOOD_PATH} fill={color} />
    </svg>
  );
}

export function RobinhoodMark({ size = 20, withLabel = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        className="inline-flex items-center justify-center rounded-sm border border-welock-border bg-welock-surface"
        style={{ width: size + 8, height: size + 8 }}
      >
        <RobinhoodGlyph size={size - 3} color="#00DC82" />
      </span>
      {withLabel && (
        <span className="font-mono text-xs tracking-wide text-welock-textSecondary">
          Robinhood Chain
        </span>
      )}
    </div>
  );
}
